import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { InspectionProvider } from '../../hooks/InspectionProvider';
import { LandingPage } from './LandingPage';
import { PlateConfirmPage } from './PlateConfirmPage';
import { GuidedCapturePage } from './GuidedCapturePage';
import { VideoCapturePage } from './VideoCapturePage';
import { UploadPage } from './UploadPage';
import { StatusPage } from './StatusPage';
import { HistoryPage } from './HistoryPage';

export const ClientRouter: React.FC = () => {
  return (
    <InspectionProvider>
      <Routes>
        {/* Landing */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/inspecao" element={<Navigate to="/inspecao/nova" replace />} />
        <Route path="/inspecao/nova" element={<Navigate to="/inspecao/placa" replace />} />
        
        {/* Flow: Plate -> Capture -> Video (opcional) -> Upload -> Status */}
        <Route path="/inspecao/placa" element={<PlateConfirmPage />} />
        <Route path="/inspecao/captura" element={<GuidedCapturePage />} />
        <Route path="/inspecao/video" element={<VideoCapturePage />} />
        <Route path="/inspecao/upload" element={<UploadPage />} />
        
        {/* Status with optional inspection ID */}
        <Route path="/inspecao/status" element={<StatusPage />} />
        <Route path="/inspecao/status/:inspectionId" element={<StatusPage />} />
        
        {/* History */}
        <Route path="/inspecao/historico" element={<HistoryPage />} />
        
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </InspectionProvider>
  );
};
